<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        v-if="id === ''"
        @back="back"
        title
        :content="$t('adicionar-novo-usuario')"
      ></el-page-header>
      <el-page-header
        v-if="id !== ''"
        @back="back"
        title
        :content="$t('atualizar-usuario')"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-row :gutter="5" v-if="user.type !== '5' && !id">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-radio
            v-model="options"
            @change="getroles('change')"
            v-if="user.type === '1'"
            label="1"
            ><span class="options"
              >Quero cadastrar um usuário interno</span
            ></el-radio
          >
          <el-radio
            v-model="options"
            @change="getroles('change')"
            v-if="user.type !== '2'"
            label="2"
            ><span class="options"
              >Quero cadastrar para um cliente</span
            ></el-radio
          >
          <el-radio
            v-model="options"
            @change="getroles('change')"
            v-else
            label="2"
            ><span class="options"
              >Quero cadastrar para a matriz</span
            ></el-radio
          >
          <el-radio
            v-model="options"
            @change="getroles('change')"
            v-if="user.type === '1'"
            label="3"
            ><span class="options"
              >Quero cadastrar para uma licença</span
            ></el-radio
          >
          <el-radio
            v-model="options"
            @change="getroles('change')"
            v-else-if="user.type === '3'"
            label="3"
            ><span class="options">Quero cadastrar um usuário</span></el-radio
          >
          <el-radio
            v-model="options"
            @change="getroles('change')"
            v-if="user.type !== '2'"
            label="4"
            ><span class="options">Quero cadastrar um motorista</span></el-radio
          >
          <el-radio v-model="options" @change="getroles('change')" label="5"
            ><span class="options"
              >Quero cadastrar para uma filial</span
            ></el-radio
          >
        </el-col>
      </el-row>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-position="top"
        v-show="options !== ''"
      >
        <el-row :gutter="5">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('nome')" prop="name">
              <el-input
                maxlength="80"
                ref="name"
                v-model="ruleForm.name"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5" :offset="1">
            <el-form-item
              :label="$t('ativo')"
              prop="active"
              class="is-required"
            >
              <el-switch
                v-model="ruleForm.active"
                inactive-color="#ff4949"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item :label="$t('email')" prop="mail">
          <el-col :xs="24" :sm="18" :md="18" :lg="8" :xl="8">
            <el-input
              type="email"
              ref="mail"
              v-model="ruleForm.mail"
              maxlength="255"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-row :gutter="5">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('login')" prop="username">
              <el-input
                ref="username"
                maxlength="16"
                :disabled="id !== ''"
                v-model="ruleForm.username"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="8" :xl="8">
            <el-form-item :label="$t('senha')" prop="password">
              <el-input
                ref="password"
                v-model="ruleForm.password"
                readonly
                :placeholder="id !== '' ? 'Mantém a senha atual' : ''"
              >
                <el-button
                  slot="append"
                  icon="el-icon-refresh"
                  @click="ruleForm.password = generatePassword()"
                  >{{ ruleForm.password ? "Gerar outra" : "Gerar nova senha" }}</el-button
                >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5" v-if="!hascustomer">
          <el-col :xs="15" :sm="10" :md="10" :lg="8" :xl="8">
            <el-form-item
              v-if="
                (options === '2' && (user.type === '1' || user.type === '3')) ||
                (options === '5' &&
                  (user.type === '1' ||
                    user.type === '2' ||
                    user.type === '3')) ||
                (options === '3' && user.type === '1')
              "
              :label="
                options === '2'
                  ? $t('cliente')
                  : options === '5'
                  ? $t('filial')
                  : $t('licenca')
              "
              prop="customer"
            >
              <CustomerList
                v-model="ruleForm.customer"
                v-bind:current="customers ? customers.id : ''"
                :customerType="
                  options === '2'
                    ? 1
                    : options === '5'
                    ? 3
                    : options === '3'
                    ? 2
                    : 0
                "
                v-on:selected="selectedCustomer"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5" v-if="options === '2' || options === '5'">
          <el-col :xs="15" :sm="10" :md="10" :lg="8" :xl="8">
            <el-form-item :label="$t('departamento')" prop="department">
              <DepartmentList
                ref="department"
                v-model="ruleForm.department"
                v-bind:customer="ruleForm.customer"
                v-bind:current="ruleForm.department"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="5"
          v-if="options === '1' || options === '2' || options === '3'"
        >
          <el-col :xs="15" :sm="10" :md="10" :lg="8" :xl="8">
            <el-form-item :label="$t('pdv')" prop="pdv">
              <el-checkbox v-model="ruleForm.pdv">Atendente PDV</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="10" :md="10" :lg="8" :xl="8">
            <el-form-item :label="$t('autorizador')" prop="authorization">
              <!-- Atendente de loja (cliente): autorizadores são os usuários da licença (tipo 3),
                   por isso não filtra pela loja selecionada -->
              <UserList
                ref="authorization"
                v-model="ruleForm.authorization"
                v-bind:customer="options === '2' ? '' : ruleForm.customer"
                v-bind:current="ruleForm.authorization"
                :disabled="!ruleForm.pdv"
                :type="3"
                :multiple="true"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- Atendente de loja (cliente): o PDV é a própria loja selecionada acima -->
        <el-row :gutter="5" v-if="ruleForm.pdv && options !== '2'">
          <el-col :xs="15" :sm="10" :md="10" :lg="8" :xl="8">
            <el-form-item :label="$t('cliente')" prop="customerPdv">
              <CustomerList
                v-model="ruleForm.customerPdv"
                v-bind:current="customerPdv ? customerPdv.id : ''"
                :customerType="1"
                :multiple="false"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5" v-if="options === '4'">
          <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8">
            <el-form-item :label="$t('telefone')" prop="phone">
              <el-input
                ref="phone"
                maxlength="16"
                v-model="ruleForm.phone"
                v-mask="['(##) ####-####', '(##) #####-####']"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8">
            <el-form-item :label="$t('equipe')" prop="team">
              <TeamList
                v-model="ruleForm.team"
                v-bind:current="ruleForm.team"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8">
            <el-form-item :label="$t('imei')" prop="imei">
              <el-input v-model="ruleForm.imei"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-tabs v-model="activeTab">
          <el-tab-pane :label="$t('papel')" name="tabroles">
            <el-table
              :data="roles"
              stripe
              ref="tableRoles"
              style="width: 100%"
              :default-sort="{ prop: 'code', order: 'ascending' }"
            >
              <el-table-column type="selection" width="180"></el-table-column>
              <el-table-column
                sortable
                prop="code"
                :label="$t('codigo')"
              ></el-table-column>
              <el-table-column
                sortable
                prop="name"
                :label="$t('nome')"
              ></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane
            v-if="id !== '' && user.type === '1'"
            label="Acessos de admin"
            name="tabadminaccess"
            lazy
          >
            <UserAdminAccess :userId="id" />
          </el-tab-pane>
        </el-tabs>
        <br />
        <el-form-item style="text-align: center" class="actionWrapper">
          <el-button
            type="warning"
            v-if="id === ''"
            autofocus
            @click="submitForm('ruleForm')"
            >{{ $t("adicionar") }}</el-button
          >
          <el-button
            type="warning"
            v-if="id !== ''"
            autofocus
            @click="editForm('ruleForm')"
            >{{ $t("atualizar") }}</el-button
          >
          <el-button @click="back()">{{ $t("voltar") }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <PasswordCreatedDialog
      :visible="created.visible"
      :username="created.username"
      :password="created.password"
      @close="afterPasswordShown"
    />
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { RoleService } from "@/services/role/role.services";
import { UserService } from "@/services/users/user.services";
import UserTypeEnum from "@/xpost/enums/UserTypeEnum";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import DepartmentList from "@/xpost/views/register/department/DepartmentList.vue";
import UserList from "./UserList";
import TeamList from "@/xpost/views/umov/team/TeamList";
import PasswordCreatedDialog from "@/xpost/components/PasswordCreatedDialog.vue";
import UserAdminAccess from "./UserAdminAccess.vue";
import { generatePassword } from "@/utils/password";

export default {
  name: "UserAdd",
  components: {
    CustomerList,
    DepartmentList,
    PasswordCreatedDialog,
    TeamList,
    UserAdminAccess,
    UserList,
  },
  enums: {
    UserTypeEnum,
  },
  computed: {
    listType() {
      return UserTypeEnum;
    },
  },
  data() {
    var checkPassword = (rule, value, callback) => {
      const vm = this;
      if (vm.id !== "") {
        return callback();
      }

      if (!value) {
        return callback(new Error(i18n.tc("verifiq-obrigatorio")));
      }

      callback();
    };
    return {
      id: "",
      roles: [],
      customers: {},
      customerPdv: {},
      customer: [],
      branchs: [],
      selectedsRoles: [],
      options: "",
      activeTab: "tabroles",
      user: {
        type: "1",
      },
      hascustomer: false,
      created: {
        visible: false,
        username: "",
        password: "",
      },
      ruleForm: {
        code: "",
        name: "",
        mail: "",
        active: true,
        pdv: false,
        authorization: "",
        username: "",
        password: "",
        customer: "",
        type: "1",
        department: "",
        role: "1",
        phone: "",
        imei: "",
        team: "",
        customerPdv: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-obrigatorio"),
            trigger: "blur",
          },
        ],
        mail: [
          {
            required: true,
            message: i18n.tc("email-obrigatorio"),
            trigger: "blur",
          },
        ],
        username: [
          {
            required: true,
            message: i18n.tc("login-obrigatorio"),
            trigger: "blur",
          },
        ],
        password: {
          validator: checkPassword,
          trigger: "blur",
        },
        phone: [
          {
            required: true,
            message: i18n.tc("telefone-obrigatorio"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    generatePassword,
    showPassword(username, password) {
      this.created = { visible: true, username, password };
    },
    afterPasswordShown() {
      this.created.visible = false;
      this.$router.push({ name: "user" });
    },
    selectedCustomer: function () {
      var vm = this;

      if (vm.ruleForm.department) {
        if (vm.$refs.department) vm.$refs.department.fetchDepartment();
      }
    },
    back() {
      var vm = this;
      vm.$router.push({ name: "user" });
    },
    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      UserService.get(vm.id)
        .then((response) => {
          vm.ruleForm.name = response.user.name;
          vm.ruleForm.code = response.user.code;
          vm.ruleForm.mail = response.user.mail;
          vm.ruleForm.phone = response.user.phone
            ? `(${response.user.phone.substring(
                0,
                2
              )}) ${response.user.phone.substring(
                2,
                7
              )}-${response.user.phone.substring(7, 11)}`
            : "";
          vm.ruleForm.imei = response.user.imei;
          vm.ruleForm.active = response.user.active;
          vm.ruleForm.pdv = response.user.pdv;
          vm.ruleForm.authorization = response.user.authorization;
          vm.ruleForm.username = response.user.username;
          vm.options = response.user.type;
          vm.customers = response.user.customers;
          vm.customerPdv = response.user.customerPdv;
          vm.ruleForm.customerPdv = response.user.customerPdv ? response.user.customerPdv.id : '';
          vm.ruleForm.team = response.user.team;
          vm.ruleForm.department = response.user.department
            ? response.user.department.id
            : null;
          if (response.user.customers) {
            vm.ruleForm.customer = response.user.customers.id;
            vm.selectedCustomer();
          }

          vm.selectedsRoles = response.user.roles;
          vm.getroles("start");
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error.message,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.ruleForm.phone = vm.ruleForm.phone
        .replace("(", "")
        .replace(")", "")
        .replace("-", "")
        .replace(" ", "");

      if (vm.$refs.tableRoles.selection.length === 0) {
        return vm.$message({
          type: "error",
          message: "É obrigatório realizar um papel ao usuário!",
        });
      }
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          UserService.add(
            vm.ruleForm.name,
            vm.ruleForm.mail,
            vm.ruleForm.active,
            vm.ruleForm.username,
            vm.options,
            vm.ruleForm.password,
            vm.$refs.tableRoles.selection,
            vm.ruleForm.customer,
            vm.ruleForm.department,
            vm.ruleForm.pdv,
            vm.ruleForm.authorization,
            vm.options === "2" ? vm.ruleForm.customer : vm.ruleForm.customerPdv,
            vm.ruleForm.phone,
            vm.ruleForm.team,
            vm.ruleForm.imei
          )
            .then(() => {
              this.$message({
                type: "success",
                message: i18n.tc("usuario-adicionado-sucesso"),
              });
              vm.showPassword(vm.ruleForm.username, vm.ruleForm.password);
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      if (vm.$refs.tableRoles.selection.length === 0) {
        return vm.$message({
          type: "error",
          message: "É obrigatório realizar um papel ao usuário!",
        });
      }
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          UserService.update(
            vm.id,
            vm.ruleForm.name,
            vm.ruleForm.mail,
            vm.ruleForm.active,
            vm.options,
            vm.ruleForm.password,
            vm.$refs.tableRoles.selection,
            vm.ruleForm.customer,
            vm.ruleForm.department,
            vm.ruleForm.pdv,
            vm.ruleForm.authorization,
            vm.options === "2" ? vm.ruleForm.customer : vm.ruleForm.customerPdv,
            vm.ruleForm.phone,
            vm.ruleForm.team,
            vm.ruleForm.imei
          )
            .then(() => {
              this.$message({
                type: "success",
                message: i18n.tc("usuario-atualizado-sucesso"),
              });
              if (vm.ruleForm.password) {
                return vm.showPassword(vm.ruleForm.username, vm.ruleForm.password);
              }
              setTimeout(() => {
                vm.$router.push({ name: "user" });
              }, 200);
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getroles: function (state) {
      const vm = this;
      if (!vm.options) {
        return false;
      }
      if (!vm.id) {
        vm.ruleForm.department = "";
        vm.ruleForm.customer = "";
      }
      const loading = vm.$loading(vm.$options.loading);
      RoleService.type(vm.options)
        .then((response) => {
          vm.roles = response.data;
          if (state === "start" && vm.id) {
            setTimeout(() => {
              for (const record of vm.selectedsRoles) {
                const index = vm.roles.findIndex((x) => x.id === record.id);
                if (index !== -1) {
                  vm.$refs.tableRoles.toggleRowSelection(vm.roles[index]);
                }
              }
            }, 200);
          }
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((user) => {
        vm.hascustomer = user.type === "5";
        if (vm.hascustomer) {
          vm.options = user.type;
        }
        vm.user = user;
        vm.ruleForm.type = user.type;
        if (this.$route.params.id) {
          this.id = this.$route.params.id;
          vm.get();
        } else {
          vm.ruleForm.password = generatePassword();
          vm.getroles("change");
          //vm.getcustomers();
        }
        vm.$refs.name.$el.children[0].focus();
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}

form {
  margin-top: 20px;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}

.options {
  font-size: 16px;
}
</style>
